export const changeTypeBySchema = (schema, key, value) => {
  const { type } = schema.find((item) => item.key === key);
  switch (type) {
    case 'number':
      return Number(value);
    case 'boolean':
      return !!value;
    default:
      return String(value);
  }
};
